import iosShareIcon from 'assets/svg/ios-share.svg';
import { Container, Description, Tap } from './Styles';
import { Icon } from 'styles/AppStyles';
import { currentContentConfig } from 'utils/handleCurrentContentConfig';

const PWA = () => (
  <Container>
    <Icon src={currentContentConfig.icon_512x512} width={80} />
    <Description>Install this web page to your home screen for a better experience</Description>
    <Tap>
      Tap <Icon src={iosShareIcon} width={20} /> then 'Add to home screen'
    </Tap>
  </Container>
);

export default PWA;
